<template>
  <header class="subHeader">
    <div class="content-header">DASHBOARD</div>
    <div class="content-body">Quick stats about your events.</div>
  </header>
</template>
<script>
export default {
  name: 'subHeaderDash',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderDash.vue?d61ed512